var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssignSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 101.4 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #d5dae5;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-4 {\n        fill: #eaeef9;\n      }\n\n      .cls-5 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 44.6,
    y1: 56.3,
    x2: 40.5,
    y2: 48,
    gradientTransform: "translate(0 104) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8ed259"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53c28c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 51.4,
    y1: 58.2,
    x2: 59.4,
    y2: 53.2,
    gradientTransform: "translate(0 104) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8ed259"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53c28c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_47889",
    "data-name": "Group 47889"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_17",
    "data-name": 17
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_758",
    "data-name": "Group 758"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    className: "cls-4",
    d: "M101.4,50.9c0,14.2-5.8,27-15.1,36.2-9.1,9.1-21.7,14.6-35.6,14.6s-26.4-5.6-35.6-14.6C5.8,77.9,0,65.1,0,50.9,0,22.8,22.7.1,50.7.1s50.7,22.8,50.7,50.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    "data-name": "Vector 2",
    className: "cls-5",
    d: "M86.3,24.3v62.8c-9.1,9.1-21.7,14.6-35.6,14.6s-26.4-5.6-35.6-14.6V24.3h71.2Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    "data-name": "Vector 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.9,56.4l-13.9-13.9-4.7,4.7,13.9,13.9,4.7-4.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4",
    "data-name": "Vector 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63.4,35.5l-20.8,20.8,4.7,4.7,20.8-20.8-4.7-4.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    "data-name": "Vector 5",
    className: "cls-2",
    d: "M68.9,69.6h-36.4v4.6h36.4v-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    "data-name": "Vector 6",
    className: "cls-2",
    d: "M68.9,79.7h-36.4v4.6h36.4v-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    "data-name": "Vector 7",
    className: "cls-2",
    d: "M60,89.9h-18.6v4.6h18.6v-4.6Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignSuccess);
export default __webpack_public_path__ + "static/media/assignSuccess.ec3fab6e7b43a13a9f9024651dc8d16f.svg";
export { ForwardRef as ReactComponent };